import { useSession } from "@/app/auth/SessionProvider";
import PrivateContextLoader from "@/app/components/PrivateContextLoader";
import { ReactNode } from "react";
import { Navigate } from "react-router";

export default function Private({ children }: { children: ReactNode }) {
  const { session } = useSession();
  if (!session) {
    return <Navigate to="/login" replace />;
  }
  return <PrivateContextLoader>{children}</PrivateContextLoader>;
}
